"use client"

import type { ReactNode } from "react"

import { SortControl } from "@/components/marketplace/listing/sort-control"
import type { SearchQuery } from "@/lib/types/search"

interface FacetChipRowProps {
  query: SearchQuery
  onUpdateQuery: (updates: Partial<SearchQuery>) => void
  leading?: ReactNode
  className?: string
}

export const FacetChipRow = ({ query, onUpdateQuery, leading, className }: FacetChipRowProps) => {
  return (
    <div className={`flex flex-wrap items-center gap-125 ${className ?? ""}`}>
      {leading}
      <SortControl value={query.sort} onChange={(sort) => onUpdateQuery({ sort })} chip />
    </div>
  )
}
